import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OwnerProfile = ({ owner, onContact }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-4 md:p-6 lg:p-8">
      <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground mb-6">
        Owner Information
      </h2>
      <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-6 mb-6">
        <div className="relative">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden">
            <Image
              src={owner?.avatar}
              alt={owner?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          {owner?.verified && (
            <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-success rounded-full flex items-center justify-center border-2 border-card">
              <Icon name="CheckCircle2" size={16} color="white" strokeWidth={2.5} />
            </div>
          )}
        </div>

        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground">
              {owner?.name}
            </h3>
            {owner?.verified && (
              <span className="px-2 py-1 bg-success/10 text-success text-xs font-caption font-medium rounded">
                Verified
              </span>
            )}
          </div>

          <div className="flex items-center space-x-4 mb-3">
            <div className="flex items-center space-x-1">
              <Icon name="Star" size={18} color="var(--color-accent)" strokeWidth={2} fill="var(--color-accent)" />
              <span className="font-body text-sm md:text-base font-semibold text-foreground">
                {owner?.rating}
              </span>
              <span className="font-body text-sm text-muted-foreground">
                ({owner?.reviewCount} reviews)
              </span>
            </div>
          </div>

          <div className="flex flex-wrap gap-3 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="MapPin" size={16} strokeWidth={2} />
              <span className="font-body">{owner?.location}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Calendar" size={16} strokeWidth={2} />
              <span className="font-body">Member since {owner?.memberSince}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-4 mb-6">
        <div className="flex items-start space-x-3">
          <Icon name="Truck" size={20} color="var(--color-primary)" strokeWidth={2} />
          <div>
            <p className="font-body text-sm md:text-base font-medium text-foreground">
              {owner?.totalTrailers} Trailers Listed
            </p>
            <p className="font-body text-sm text-muted-foreground">
              Active rental provider
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="Clock" size={20} color="var(--color-primary)" strokeWidth={2} />
          <div>
            <p className="font-body text-sm md:text-base font-medium text-foreground">
              Response Time: {owner?.responseTime}
            </p>
            <p className="font-body text-sm text-muted-foreground">
              Typically responds within hours
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} color="var(--color-primary)" strokeWidth={2} />
          <div>
            <p className="font-body text-sm md:text-base font-medium text-foreground">
              {owner?.completedRentals} Completed Rentals
            </p>
            <p className="font-body text-sm text-muted-foreground">
              Trusted by the community
            </p>
          </div>
        </div>
      </div>
      <Button
        variant="outline"
        size="lg"
        fullWidth
        iconName="MessageCircle"
        iconPosition="left"
        onClick={onContact}
      >
        Contact Owner
      </Button>
      {owner?.bio && (
        <div className="mt-6 pt-6 border-t border-border">
          <h4 className="font-heading text-base md:text-lg font-semibold text-foreground mb-3">
            About the Owner
          </h4>
          <p className="font-body text-sm md:text-base text-muted-foreground leading-relaxed">
            {owner?.bio}
          </p>
        </div>
      )}
    </div>
  );
};

export default OwnerProfile;